import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
  setItemNameLat,
  setItemNameTranslit,
} from '@/modules/Dictionary/__form/item';

export default class DictionaryRoomCategoryForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'roomCategory';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)({ length: 200 });
    setItemNameLat.bind(this)({ length: 200 });
    setItemNameTranslit.bind(this)({ length: 200 });
    setItemCode.bind(this)();
  }
}
